/** @jsx jsx */

import { Fragment } from 'react';

import { jsx } from '@emotion/core';

import {
  LifecycleJobStep,
  LifecycleStage,
} from 'app/entities/VersionLifecycle/types';

import CountList from './CountList';
import Progress from './Progress';
import Status from './Status';

import {
  MigrationStepName,
  PromotionStepName,
} from 'app/developer-v3/components/SidebarRight/types';

type Props = {
  progress: number;
  currentStep: LifecycleJobStep;
  stage: LifecycleStage;
};

const LifecycleProgress = ({ currentStep, progress, stage }: Props) => {
  const shouldShowCountList =
    [LifecycleStage.inProgress].includes(stage) &&
    [
      MigrationStepName.migrateZaps,
      MigrationStepName.addCustomusers,
      PromotionStepName.migrateZts,
      PromotionStepName.rebuildAllowlist,
    ].includes(currentStep.name as any);

  const isRequested = stage === LifecycleStage.requested;
  const isEstimating = stage === LifecycleStage.estimating;
  // Progress is visible once we're past the estimation phase.
  const isProgressVisible = stage && !isRequested && !isEstimating;

  return (
    <Fragment>
      <Status stage={stage} />
      {isProgressVisible && <Progress progress={progress} />}
      {shouldShowCountList && (
        <CountList
          finished={currentStep.finishedPoints}
          total={currentStep.estimatedPoints}
          type={currentStep.name}
        />
      )}
    </Fragment>
  );
};

export default LifecycleProgress;
